<template>
	<div class="hsy-dropdown" :class="cls" :style="{width: width + 'px'}">
		<div class="selected" @click="autoShow" :style="{backgroundPosition: (width - 18) + 'px, center'}">{{ selectedText }}</div>
		<transition name="fadeIn" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
			<div class="list" v-show="isShow" :style="{width: fixListWidth ? width + 'px' : 'auto'}">
				<div class="inner">
					<div class="item" v-if="!grouped" v-for="item in items" :data-title="item.label" @click="!multiple && itemClicked(item)" :class="{selected: item.selected}">
						{{ appendIdx(item) }}
						<div v-if="multiple">
							<input type="checkbox" :disabled="item.disabled" :checked="item.selected" @change="checkboxChanged(item)" :id="id(item)">
							<label :for="id(item)" @click="itemClicked(item)">{{ item.label }}</label>
						</div>
						<div v-else>
							{{ item.label }}
						</div>
					</div>
					<div v-if="grouped">
						<div v-for="group in items" class="group">
							<div class="item" :class="{selected: allItem.selected}">
								<div v-if="multiple" class="checkbox checkbox-primary">
									<input type="checkbox" class="styled styled-primary" :checked="allItem.selected" @change="allChanged(allItem)" :id="'allItem-'+aid">
									<label :for="'allItem-'+aid">全选</label>
								</div>
								<div v-else>
								</div>
							</div>
							<h3>{{ group.label }}</h3>

							<div class="item" v-for="item in group.children" :data-title="item.label" @click="!multiple && itemClicked(item)" :class="{selected: item.selected}">
								{{ appendIdx(item) }}
								<div v-if="multiple" class="checkbox checkbox-primary">
									<input type="checkbox" class="styled styled-primary" :disabled="item.disabled" :checked="item.selected" @change="checkboxChanged(item)" :id="id(item)">
									<label :for="id(item)" @click="itemClicked(item)">{{ item.label }}</label>
								</div>
								<div v-else>
									{{ item.label }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	const EMPTY_FN = () => {}
	let aid = 0
	let idx = 0

	export default {
		name: 'Dropdown',

		data() {
			return {
				selected: [],
				isShow: false,
				items: [],
				aid: 0,
				allItem: {
					selected: false
				}
			}
		},
		props: {
			data: {
				type: Array,
				default: () => []
			},
			grouped: {
				type: Boolean,
				default: false
			},
			multiple: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: 'Please choose'
			},
			width: {
				type: Number,
				default: 120
			},
			fixListWidth: {
				type: Boolean,
				default: true
			},
			cbChanged: {
				type: Function,
				default: EMPTY_FN
			},
			cbItemChanged: {
				type: Function,
				default: EMPTY_FN
			},
			cbCustomSelectedText: {
				type: Function,
				default: EMPTY_FN
			}
		},
		created: function() {
//			for(let i = 0; i < this.data[0].children.length; i++) {
//				if(this.data[0].children[i].selected == true) {
//					this.selected.push(this.data[0].children[i])
//				}
//			}
			aid++;
			this.aid = aid
			
			//		this.checkboxChanged() 
		},
		computed: {
			cls() {
				let c = {
					grouped: this.grouped,
					multiple: this.multiple
				}
				return c
			},
			selectedText() {
				let text = ''
				let fn = selected => selected.map((e) => e.label).join(',')
				if(this.cbCustomSelectedText !== EMPTY_FN) {
					text = this.cbCustomSelectedText(this.selected, fn)
				} else {
					text = fn(this.selected)
				}
				return text === '' ? this.placeholder : text
			}
		},
		watch: {
			data: {
				immediate: true,
				handler(val) {
					for(let i = 0; i < val[0].children.length; i++) {
						if(val[0].children[i].selected == true) {
							this.selected.push(val[0].children[i])
						}
					}
					this.items = this.data
				}
			}
		},
		methods: {
			renderData: function(chilLabel, data, parentLabel) { //渲染
				let reData = []
				data.forEach(function(k) {
					let kGroup = {
						label: k[chilLabel],
						value: k.id,
						selected: false
					}
					reData.push(kGroup)
				})
				let selectData = [{
					label: parentLabel,
					children: reData
				}]
				return selectData;
			},
			setData: function(reData, selectedValue, mlupls, type = "value") { //只能单个组赋值,reData为data[i].child,selectedValue为赋值数组，mlupls为是否多选,type为相等属性
				for(let a = 0; a < reData.length; a++) {
					for(let i = 0; i < selectedValue.length; i++) {
						if(reData[a][type] == selectedValue[i]) {
							reData[a].selected = true;
							break
						} else {
							reData[a].selected = false;
						}
					}
				}
				if((selectedValue[0] == null || selectedValue[0] == "") && !mlupls) {
					reData[0].selected = true;
				}
				return reData;
			},
			id(item) {
				return 'hsy-dropdown-item-' + item._idx
			},
			appendIdx(item) {
				if(item._idx === undefined) {
					item._idx = ++idx
				}
			},
			autoShow() {
				this.isShow = !this.isShow
			},
			setupTitleIfNeeded() {
				if(!this.fixListWidth) return
			},
			autoHide(evt) {
				if(!this.$el.contains(evt.target)) {
					this.isShow = false
				}
			},
			findSelected() {
				if(!this.grouped) {
					return this.data.filter(d => d.selected === true)
				}
				let items = []
				return this.data.reduce((pre, e) => {
					pre = pre.concat(e.children)
					return pre
				}, items).filter(d => d.selected === true)
			},
			itemClicked(item) {
				if(!this.multiple) {
					if(this.selected.indexOf(item) === -1) {
						this.findSelected().forEach((d) => d.selected = false)
						item.selected = true
						this.selected.pop()
						this.selected.push(item)

						if(this.cbChanged !== EMPTY_FN) {
							this.cbChanged(this.findSelected())
						}
					}
					this.$nextTick(() => {
						this.isShow = false
					})
				}
			},
			checkboxChanged(item) {
				if(this.selected === null) {
					this.selected = []
				}

				let id = this.id(item)
				item.selected = document.querySelector('#' + id).checked

				if(!item.selected) {
					this.allItem.selected=false;
					this.selected = this.selected.filter((d) => d !== item)
				} else {
					this.selected.push(item)
				}
				if(this.cbItemChanged !== EMPTY_FN) {
					this.cbItemChanged(item)
				}
				if(this.cbChanged !== EMPTY_FN) {
					this.cbChanged(this.selected)
				}
			},
			setAllItems(allse) {
				this.selected = [];
				this.items.forEach((k) => {
					k.children.forEach((a,index) => {
						a.selected = allse
						if(allse) {
							this.selected.push(a)
						} else {
							this.selected = this.selected.filter((d) => d !== a)
						}
					})
				})
			},
			allChanged(allItem) {
				allItem.selected = document.querySelector('#allItem-' + this.aid).checked
				this.setAllItems(allItem.selected)
			}
		},
		updated() {
			let allSum = 0;
			this.items.forEach((k) => {
				allSum += k.children.length;
			})
			if(this.selected.length>=allSum){
				this.allItem.selected=true;
			}
			this.setupTitleIfNeeded()
		},
		mounted() {
			this.setupTitleIfNeeded()
			document.addEventListener('click', this.autoHide, false)
		},
		destroyed() {
			document.removeEventListener('click', this.autoHide, false)
		}

	}
</script>
<style scoped="scoped">
	@import url("../../static/css/build.css");
	.checkbox {
		margin-top: 0px!important;
		margin-bottom: 0px!important;
	}
	
	.hsy-dropdown {
		font: 10px "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
		display: inline-block;
		position: relative;
	}
	
	.hsy-dropdown>.selected {
		height: 36px;
		line-height: 36px;
		border-radius: 2px;
		border: 1px solid #D0D2D9;
		font-size: 1.2em;
		padding: 0 20px 0 10px;
		color: #999999;
		cursor: pointer;
		background: url('../../static/assets/arrow.svg') no-repeat right center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.hsy-dropdown>.list {
		position: absolute;
		top: 36px;
		left: 0px;
		font-size: 1.2em;
		/*box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  background: #fff;
  border-radius: 3px;*/
		border: 1px solid #D0D2D9;
		box-shadow: 0 0 4px 0 rgba(51, 51, 51, 0.21);
		border-radius: 2px;
		background: #fff;
		z-index: 100;
	}
	
	.hsy-dropdown>.list>.inner {
		padding: 0px!important;
	}
	
	.hsy-dropdown>.list .item {
		height: 36px;
		line-height: 36px;
		padding: 0 10px;
		cursor: pointer;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		background-position: 5px center;
	}
	
	.hsy-dropdown>.list .item:hover,
	.hsy-dropdown.multiple>.list .item:hover {
		background-color: #F8F9FF;
		border-radius: 3px;
	}
	
	.hsy-dropdown>.list .item {
		/*transition: all .35s ease-in-out;*/
	}
	
	.hsy-dropdown>.list .item.selected {
		background: none;
		color: #333333;
		background: #F8F9FF;
		/*background: #7D8699 url('../../static/assets/right.svg') no-repeat 10px center;
  border-radius: 3px;
  color: #fff;
  padding-left: 35px;*/
	}
	
	.hsy-dropdown .animated {
		animation-duration: 0.35s;
		animation-fill-mode: both;
	}
	
	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	
	.hsy-dropdown .fadeIn {
		animation-name: fadeIn;
	}
	
	@keyframes fadeOut {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
		}
	}
	
	.hsy-dropdown .fadeOut {
		animation-name: fadeOut;
	}
	
	.hsy-dropdown.multiple .item {
		color: #7D8699;
		padding: 0 5px;
	}
	
	.hsy-dropdown.multiple .item.selected {
		background: none;
		padding: 0 5px;
		color: #7D8699;
		background: #F8F9FF;
	}
	
	.hsy-dropdown.multiple .item input {
		display: none;
	}
	
	.hsy-dropdown.multiple .item input+label {
		display: block;
		padding-left: 23px;
		background: url('../../static/assets/chk.svg') no-repeat 0px center;
		vertical-align: middle;
		margin: 0;
		cursor: pointer;
		font-size: 12px;
		color: #333333;
	}
	
	.hsy-dropdown.multiple .item input:checked+label {
		background: url('../../static/assets/chked.svg') no-repeat 0px center;
	}
	
	.hsy-dropdown.multiple .item input:disabled+label {
		color: #ccc;
		cursor: not-allowed;
	}
	
	.hsy-dropdown .group {
		font-size: 10px;
		max-height: 500px;
		overflow-y: auto;
	}
	
	.hsy-dropdown .group h3 {
		/*font-size: 1.2em;*/
		font-weight: 500;
		padding-left: 11px;
		cursor: default;
		line-height: 36px;
		height: 36px;
		font-size: 12px;
		color: #333333;
	}
	
	.hsy-dropdown .group .item {
		font-size: 1.2em;
	}
	
	.item>div {
		padding: 0 13px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Dropdown.vue